// Design tokens and constants for PreviewSocialSection
// Following "No Magic Strings" or "Magic Numbers" rule

export const SOCIAL_SECTION_VARIANTS = {
  BUSINESS: "business",
  COUPON: "coupon",
  LINKS: "links",
  WEBSITE: "website",
  MP3: "mp3",
} as const;

export const CSS_CLASSES = {
  BASE: "preview-social-section",
  PLACEHOLDER: "preview-social-section__placeholder",
  NETWORKS: "preview-social-section__networks",
  INITIAL_STATE: "preview-social-section--initial",
  NETWORKS_STATE: "preview-social-section--networks",
} as const;
